(ns frontend.shared.state
  (:require [frontend.logging :as logging]
            [promesa.core :as p]
            ["localforage" :as localforage]))

(defn indexeddb-last-update-path [tenant-id account-id role-id target-id]
  (str tenant-id "-" account-id "-" role-id "-" target-id "-last-update"))

(defn indexeddb-data-path [tenant-id account-id role-id target-id]
  (str tenant-id "-" account-id "-" role-id "-" target-id "-data"))

(defn clear-indexeddb [{:keys [tenant account target role-id] :as ctx} on-success! on-error!]
  (let [tenant-id (:db/id tenant)
        account-id (:db/id account)
        target-id (:db/id target)
        indexeddb-data-key (indexeddb-data-path tenant-id account-id role-id target-id)]
    (-> (.removeItem localforage indexeddb-data-key)
        (p/then (fn [resp]
                  (when on-success!
                    (on-success!))
                  (logging/info "Cleared IndexedDB - " indexeddb-data-key)))
        (p/catch (fn [err]
                   (when on-error!
                     (on-error! err))
                   (logging/error "Failed to clear indexedDB " err))))))
